export default {
  namespaced: true,
  actions: {
    create({ commit }, achievement) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.post('admin/achievements', { achievement })
    },
    destroy({ commit }, id) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.delete(`admin/achievements/${id}`)
    },
    update({ commit }, achievement) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.patch(`admin/achievements/${achievement.id}`, { achievement })
    }
  }
}
